module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-calculator.component.css
// module id = ./src/app/components/calculator/calculator-item/individual-calculator/individual-calculator.component.css
// module chunks = main